export const moduleSlug = "SCHEDULER";

export const INITIAL_SCRAPE_TASKS_STATISTIC_OFFSET = "1000";

export const schedulerFields = {
    keyword: "keyword",
    lastStartAt: "lastStartAt",
    nextStartAt: "nextStartAt"
};

export const POSSIBLE_FILTER_PARAMETERS = {
    "receiver_code": {
        "type": "string",
        "is_array": false
    },
    "fulfillment_system_code": {
        "type": "string",
        "is_array": false
    },
    "brand_code": {
        "type": "string",
        "is_array": false
    },
    "branch_codes": {
        "type": "string",
        "is_array": true
    },
    "created_by_id": {
        "type": "integer",
        "is_array": false
    },
    "include_tags": {
        "type": "string",
        "is_array": true
    },
    "exclude_tags": {
        "type": "string",
        "is_array": true
    },
    "keywords": {
        "type": "string",
        "is_array": true
    },
    "url": {
        "type": "string",
        "is_array": false
    },
    "enabled": {
        "type": "boolean",
        "is_array": false
    },
    "last_start_at_from": {
        "type": "datetime",
        "is_array": false
    },
    "last_start_at_to": {
        "type": "datetime",
        "is_array": false
    },
    "next_start_at_from": {
        "type": "datetime",
        "is_array": false
    },
    "next_start_at_to": {
        "type": "datetime",
        "is_array": false
    },
    "limit": {
        "type": "integer",
        "is_array": false
    },
    "offset": {
        "type": "integer",
        "is_array": false
    },
    "sort_field": {
        "type": "string",
        "is_array": false
    },
    "sort_direction": {
        "type": "string",
        "is_array": false
    },
};

export const SCHEDULER_DEF_FILTER = {
    limit: 25,
    offset: 0,
};

export default {moduleSlug};
